import { css, keyframes } from 'styled-components';

const actionPop = ({ maxScale }) => keyframes`
  0% {
    opacity: 0;
    transform: scale(0);
  }

  30% {
    opacity: 1;
    transform: scale(0.8);
  }

  50% {
    transform: scale(${maxScale || 1.15});
  }
`;

export const animationPop = css`
  animation: ${actionPop} 0.3s ease-in;
`;
